import { Message } from "@/types/message";
import { normalizeQuestion } from "./questionNormalizer";
import { createContextHash } from "./contextHasher";
import { isFollowUpQuestion } from "./followUpDetector";

// Create a smart cache key that considers context
export const createSmartCacheKey = (
  question: string, 
  hotelId: string, 
  messages: Message[]
): string => {
  const normalizedQuestion = normalizeQuestion(question);
  const contextHash = createContextHash(messages, question);
  const isFollowUp = isFollowUpQuestion(question, messages);
  
  // For follow-up questions, include context hash
  if (isFollowUp) {
    return `${hotelId}:${contextHash}:${normalizedQuestion}`;
  }
  
  // For standalone questions, use hotel + question
  return `${hotelId}:standalone:${normalizedQuestion}`;
};